<template>
  <div class="sport">
    <span>Sport</span>
    <select @change="$emit('change', $event)">
      <option value="0">-- Toutes --</option>
      <option v-for="item in items" :key="item.id" :value="item.id" :title="item.name+' ['+item.id+']'">{{ item.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersEventSport',
  computed: {
    items () {
      let datas = this.$store.getters['Sport/Sport/list']
      const filter = this.$store.getters['Sport/Sport/filtered']
      if (filter.length > 0) {
        datas = datas.filter(item => filter.indexOf(item.id) > -1)
      }
      return datas
    }
  }
}
</script>

<style scoped>
  .sport{
    display:flex;
    height:20px;
    align-items:center;
    margin-bottom:10px
  }
  .sport > select{
    height:18px;
    margin-left:5px
  }
</style>
